import React from "react";
import { Box, Grid, Typography, Divider } from "@mui/material";
import TrendsChart from "../../../components/charts/TrendsChart";

export default function PlayerStats({ data, theme }) {
  if (!data?.playerRatings || data.playerRatings.length === 0) return null;

  const isDark = theme.palette.mode === "dark";

  const containerSx = {
    backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.02)",
    border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
    borderRadius: 1,
    p: 2.5,
    boxShadow: isDark ? "0 2px 8px rgba(0,0,0,0.3)" : "0 2px 8px rgba(0,0,0,0.1)"
  };

  return (
    <Box sx={{ mt: 6 }}>
      <Divider sx={{ mb: 4, borderColor: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)" }} />

      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          mb: 3,
          color: theme.palette.text.primary,
          fontWeight: 600,
          letterSpacing: "0.05em"
        }}
      >
        Players
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Box sx={containerSx}>
            <Typography
              variant="h6"
              sx={{ mb: 2, color: theme.palette.text.secondary, textAlign: "center" }}
            >
              Games & Win Rate by Rating
            </Typography>
            <TrendsChart
              data={data.playerRatings}
              barDataKey="games"
              lineDataKey="winRate"
              barLabel="Games"
              lineLabel="Win Rate"
              barColor="#a855f7"
              lineColor="#22d3ee"
              barAxisLabel="Games"
              lineAxisLabel="Win Rate"
              height={320}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box sx={containerSx}>
            <Typography
              variant="h6"
              sx={{ mb: 2, color: theme.palette.text.secondary, textAlign: "center" }}
            >
              Players & Games per Player by Rating
            </Typography>
            <TrendsChart
              data={data.playerRatings}
              barDataKey="players"
              lineDataKey="gamesPerPlayer"
              barLabel="Players"
              lineLabel="Games per Player"
              barColor="#f97316"
              lineColor="#4ade80"
              barAxisLabel="Players"
              lineAxisLabel="Games per Player"
              lineValueSuffix=""
              height={320}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
